import Cookies from 'js-cookie'
import { atom } from 'recoil'

const cookiesEffect = ({ setSelf, onSet }) => {
  const key = 'isFirstLoading'
  let currentValue: string | null = Cookies.get(key) || null

  const savedValue = Boolean(parseInt(currentValue || '1'))
  setSelf(savedValue)

  onSet((newValue, _, isReset) => {
    isReset ? Cookies.remove(key) : Cookies.set(key, newValue ? '1' : '0')
  })
}

const isFirstLoadingState = atom<boolean>({
  key: 'isFirstLoadingState',
  default: true,
  effects: [cookiesEffect]
})

export default isFirstLoadingState
